<section class="register-user__location" [formGroup]="form()">
  <ci-text-field-outlined
    #inputLocation 
    class="register-user__input-location"
    type="text"
    [value]="getCurrentStartLocation()"
    [label]="'¿' + ('Dónde quieres empezar tu ruta' | translate) + '?'"
    [placeholder]="'Selecciona un punto de partida' | translate"
    required
    [error]="isInvalidFieldSignal()"
    [supportingText]="'Obligatorio' | translate"
    [errorText]="'El punto de partida es obligatorio' | translate"
    (input)="handleInput($event)"
    (focusin)="focusin($event)" 
  ></ci-text-field-outlined>
  
  <ci-switch 
    #switchLocation
    class="register-user__switch-location"
    [checked]="getCurrentEndLocation()"
    [disabled]="isDisabledEndLocationSwitch()"
    (change)="handleSwitchLocationChange($event)"
  >
    <span class="switch-location__label ci-paragraph-p1-regular">
      {{ 'Establecer el punto final igual que el punto de inicio' | translate }}
    </span>
  </ci-switch>
</section>